import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';

export const base: ThemedFunctor = ({ theme }) => css`
    ${getSpacing.padding(theme, SpacingName.SMALLER)};
    ${getTypography(theme, TypographyName.SMALL)};
    background-color: ${theme.palettes.neutrals.darkest};
    border-radius: 7px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
    color: ${theme.palettes.neutrals.lightest};
    display: inline-flex;
    height: 2.2rem;
    justify-content: center;
    min-width: 4rem;
`;

export const wrapper = () => css`
  align-items: center;
  display: inline-flex;
`;

export const count: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginLeft(theme, SpacingName.SMALLEST)};
`;
